import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { adminApi, apiError, EMAIL_KIND, fmtDate } from "@/lib/api";
import { EmailBadge } from "./EmailBadge";

export const EmailsTab = () => {
  const [emails, setEmails] = useState([]);
  const [problems, setProblems] = useState(false);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.get("/emails", { params: problems ? { problems: true } : {} });
      setEmails(data);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  }, [problems]);

  useEffect(() => { load(); }, [load]);

  const sync = async () => {
    setSyncing(true);
    try {
      const { data } = await adminApi.post("/emails/refresh");
      toast.success(data.enabled ? `${data.checked} e-mail(s) vérifié(s), ${data.updated} statut(s) mis à jour` : "Suivi Resend indisponible (clé non configurée)");
      await load();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input type="checkbox" data-testid="emails-problems-filter" checked={problems} onChange={(e) => setProblems(e.target.checked)} className="w-4 h-4 accent-orange-600" />
          Problèmes uniquement (rejeté / spam / échec)
        </label>
        <button type="button" onClick={sync} disabled={syncing} data-testid="emails-refresh-button" className="btn-ghost-ice !py-2.5">
          <RefreshCw className={`w-4 h-4 ${syncing ? "animate-spin" : ""}`} /> Actualiser les statuts
        </button>
        <span className="text-sm text-slate-500">{emails.length} e-mail(s) — 100 derniers</span>
      </div>
      <div className="admin-table-wrap">
        <table data-testid="emails-table" className="admin-table">
          <thead><tr><th>Date</th><th>Destinataire</th><th>Type</th><th>Référence</th><th>Statut</th></tr></thead>
          <tbody>
            {emails.map((m, i) => (
              <tr key={`${m.at}-${i}`} data-testid={`email-row-${i}`}>
                <td>{fmtDate(m.at)}</td>
                <td>{m.to}</td>
                <td>{EMAIL_KIND[m.kind] || m.kind}</td>
                <td className="font-mono text-xs">{m.ref?.split(":")[1]}</td>
                <td><EmailBadge log={m} testId={`email-status-${i}`} /></td>
              </tr>
            ))}
            {!loading && emails.length === 0 && <tr><td colSpan={5} className="text-center text-slate-500 py-10">Aucun e-mail.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
